import React from 'react';

import { getFeedbackStepDetails } from '@/components/shared/FeedbackScale';
import { classNames } from '@/helpers/classNames';
import { ImpactStyle } from '@capacitor/haptics';
import { Haptics } from '@capacitor/haptics';

import styles from './FeedbackSlider.module.scss';

type Props = {
	className?: string;
	value?: number;
	stepLabelMap?: string[];
	onChange?: (value: number) => void;
};

export const FeedbackSlider: React.FC<Props> = ({
	className,
	value = 1,
	stepLabelMap,
	onChange,
}) => {
	const clamped = Math.min(Math.max(value, 1), 5);
	const positionOffsetPercentage = ((clamped - 1) / 4) * 100;
	const overlayWidthPercentage = ((clamped - 1) / 4) * 100;
	const { emoji, label } = getFeedbackStepDetails(clamped, stepLabelMap);

	return (
		<div className={classNames([styles['root'], className])}>
			<div className={styles['steps']}>
				{[1, 2, 3, 4, 5].map((step) => (
					<div
						key={step}
						onTouchStart={() => {
							Haptics.impact({ style: ImpactStyle.Light });
							onChange?.(step);
						}}
						onMouseDown={() => {
							Haptics.impact({ style: ImpactStyle.Light });
							onChange?.(step);
						}}
					>
						{step}
					</div>
				))}
			</div>

			<div className={styles['scale-limits']}>
				<div
					className={styles['overlay']}
					style={{ width: `${overlayWidthPercentage}%` }}
				>
					<div className={styles['left']} />
					<div className={styles['middle']} />
					<div className={styles['right']} />
				</div>

				<div
					className={styles['position-indicator']}
					style={{ left: `${positionOffsetPercentage}%` }}
				>
					<div className={styles['position-emoji']}>{emoji}</div>
				</div>

				<div
					className={styles['position-label']}
					style={{ left: `${positionOffsetPercentage}%` }}
				>
					{label}
				</div>
			</div>

			<div className={styles['steps-background']} />
		</div>
	);
};
